export default __webpack_public_path__ + "static/media/3.c04f239c.png";